import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import FileUploader from "components/FileUploader";
import { epdEditorStore } from "../EPDEditorStore";
import { IconPDF } from "utils";

const EPDFile = () => {
  const { t } = useTranslation();
  const [uploadInProgress, setUploadInProgress] = React.useState(false);

  React.useEffect(() => {
    if (uploadInProgress) {
      epdEditorStore.setSaveValidationErrors(true);
    } else {
      epdEditorStore.checkSaveValidation();
    }
  }, [uploadInProgress]);

  const onRemoveFiles = (id: string) => {
    epdEditorStore.setFilesToRemove([...epdEditorStore.filesToRemove, id]);
  };

  const addToUploadFiles = (files: File[]) => {
    epdEditorStore.setFilesToUpload(files);
  };

  return (
    <FileUploader
      labelName={t("EPDEditor.EPDFile")}
      name="files"
      onChange={addToUploadFiles}
      files={epdEditorStore.data.files}
      onRemove={onRemoveFiles}
      setInProgress={setUploadInProgress}
      maxFileSize={80 * 1024 * 1024}
      fileTypes={[".pdf"]}
      fileIcon={IconPDF}
    />
  );
};

export default observer(EPDFile);
